import {
  MAutocomplete,
  MDatePicker,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import useFilteredProcedures from "@app/pages/samples/hook/useFilteredProcedures";
import useAnalysis from "@app/pages/samples/utils/useAnalysis";
import {
  useDetector,
  useEquipment,
  useEquipmentMide,
  useUser,
} from "@services/servicesGenericsTables";
import React, { useMemo } from "react";
import { useFormContext } from "react-hook-form";

const CountingBRBT = () => {
  const form = useFormContext();
  const { userList } = useUser();
  const { currentCounting } = useAnalysis();
  const filteredProcedures = useFilteredProcedures("CON");
  // cuando la tabla de relacion equipos analisis este ok, se debe cambiar el uso de equipmentList por equipmentMideListFiltered
  const { /* equipmentMideListFiltered, */ loading } = useEquipmentMide();
  const { equipmentList } = useEquipment();

  const { detectorsList } = useDetector();

  const watchEquipment = form.watch("counting_equipment");

  const countingValidValue = useMemo(
    () => form.watch("counting_valid"),
    [form]
  );

  const stylesInput = useMemo(() => {
    if (countingValidValue === "N") {
      return { backgroundColor: "#ef233c" };
    } else if (countingValidValue === "S") {
      return { backgroundColor: "#a7c957" };
    }
    return {};
  }, [countingValidValue]);

  const filterDetectors = useMemo(() => {
    const idsEquipment = watchEquipment?.map((e) => e.id);
    return detectorsList.filter(
      (detector) => idsEquipment?.includes(detector.equipment.id) || false
    );
  }, [watchEquipment, detectorsList]);

  return (
    <>
      {currentCounting.index !== undefined ? (
        <React.Fragment key={currentCounting.id}>
          <ResponsiveFormContainer columns={5}>
            <MAutocomplete
              key={`counting_analyst-${form.getValues("counting_analyst")}`}
              name="counting_analyst"
              options={userList}
              label="Seleccione un analista"
              getOptionLabel={(option) => option.username || ""}
              validation={{ required: "El analista es requerido" }}
              disabled={!currentCounting.canEdit}
            />

            <MAutocomplete
              key={`counting_procedure-${form.getValues("counting_procedure")}`}
              name="counting_procedure"
              options={filteredProcedures}
              label="Procedimiento MLPMA"
              getOptionLabel={(option) => `${option.numop}` || ""}
              disabled={!currentCounting.canEdit}
            />

            <MAutocomplete
              key={`counting_equipment-${form.getValues("counting_equipment")}`}
              name="counting_equipment"
              options={equipmentList}
              label="Seleccione un Equipo"
              getOptionLabel={(option) =>
                `${option.codigo} - ${option.descripcion}` || ""
              }
              validation={{ required: "El equipo es requerido" }}
              loading={loading}
              disabled={!currentCounting.canEdit}
              multiple={true}
            />
            <MAutocomplete
              key={JSON.stringify(form.getValues("counting_detector"))}
              name="counting_detector"
              options={filterDetectors}
              label="Detector"
              getOptionLabel={(option) => `${option.name}` || ""}
              multiple={true}
              disabled={!currentCounting.canEdit}
            />
            <MDatePicker
              key="counting_date"
              name="counting_date"
              pickerType="date"
              label="Fecha de contaje"
              validation={{
                required: "La fecha de contaje es requerida",
              }}
              disabled={!currentCounting.canEdit}
            />
            <MTextField
              name="total_sample_counting_time"
              placeholder="Tiempo de contaje (min)"
              label="Tiempo de contaje (min)"
              type="number"
              validation={{ required: "El tiempo total es requerido" }}
              fullWidth
              step="0.01"
              disabled={!currentCounting.canEdit}
            />
            <MTextField
              name="first_counting_cpm"
              placeholder="cpm muestra ventana alfa"
              label="cpm muestra ventana alfa"
              type="number"
              validation={{ required: "El cpm es requerido" }}
              fullWidth
              step="0.01"
              disabled={!currentCounting.canEdit}
            />
            <MTextField
              name="second_counting_cpm"
              placeholder="cpm muestra ventana beta"
              label="cpm muestra ventana beta"
              type="number"
              validation={{ required: "El cpm es requerido" }}
              fullWidth
              step="0.01"
              disabled={!currentCounting.canEdit}
            />
            <MTextField
              name="counting_valid"
              placeholder="Contaje Válido"
              label="Contaje Válido"
              type="text"
              fullWidth
              disabled
              style={stylesInput}
            />
          </ResponsiveFormContainer>
        </React.Fragment>
      ) : null}
    </>
  );
};

export default CountingBRBT;
